import {registerUIService} from '@lib/ui-services/UIServicesRegistry'
import {UIServiceBase} from '@lib/ui-services/UIServiceBase'
import {initializeJQueryComponent} from '@lib/JQueryRegistry'
import Notification from '@lib/components/common/Notification'
import Application from '@lib/Application'

export default class XMessageUIService extends UIServiceBase {

    /**
     * Initializes the service.
     * Finds references to all elements that may be used.
     *
     * @protected
     */
    initializeService() {
        this.container = $('#response-messages-container')

        let initialMessages = Application.getInstance().getOptions().getInitialMessages()
        initialMessages.forEach(msg => {
            this.pushNotification(msg)
        })
    }

    /**
     * @public
     * @param {object} notification
     */
    pushNotification(notification) {
        let element = $(this.buildNotificationTemplate(notification, (notification.Type || notification.type)))
        element.appendTo(this.container)

        initializeJQueryComponent(Notification, element)
    }

    /**
     *
     * @param {object} notification
     * @param {string} type
     * @return {string}
     */
    buildNotificationTemplate(notification, type) {
        return `
            <div class="w-notification message-${type}" data-timeout="${notification.Timeout || notification.timeout}">
                <span>
                    ${this.buildNotificationIconTemplate(type)}
                </span>

                <span>
                    <span>${notification.Text || notification.text}</span>
                    <span class="w-notification-close">
                        <svg width="12" height="12" viewBox="0 0 9 8">
                            <path fill="#ffffff" fillRule="nonzero" d="M4.772 5.468L2.134 8.106.772 6.744l2.639-2.638L.772 1.468 2.134.106l2.638 2.638L7.411.106l1.361 1.362-2.638 2.638 2.638 2.638-1.361 1.362-2.639-2.638z"/>
                        </svg>
                    </span>
                </span>
            </div>
        `
    }

    buildNotificationIconTemplate(type) {
        switch (type) {
            case 'success': {
                return `
                    <svg width="14" height="14" viewBox="0 0 14 14">
                        <path fill="#FFF" d="M11.854 4.474l-.3-.319a.48.48 0 0 0-.706 0L5.779 9.087 3.152 6.288a.481.481 0 0 0-.707 0l-.3.319A.547.547 0 0 0 2 6.983c0 .143.052.277.146.377l2.966 3.16a.119.119 0 0 0 .013.017l.3.313c.094.1.22.15.354.15.135 0 .26-.05.355-.15l.3-.316.01-.014 5.41-5.294a.556.556 0 0 0 0-.752z"/>
                    </svg>
                `;
            }

            case 'danger': {
                return `
                    <svg width="14" height="14" viewBox="0 0 16 16">
                        <path fill="#FFFFFF" d="M15.725 12.887L9.324 1.801a1.55 1.55 0 0 0-1.356-.783 1.55 1.55 0 0 0-1.355.783l-6.4 11.086a1.549 1.549 0 0 0 0 1.565c.282.49.789.783 1.355.783h12.801a1.55 1.55 0 0 0 1.356-.783 1.55 1.55 0 0 0 0-1.565zm-7.756.544a1.02 1.02 0 0 1 0-2.037 1.02 1.02 0 0 1 0 2.037zm1.025-4.355a1.027 1.027 0 0 1-2.051 0V4.37c0-.268.217-.486.486-.486h1.08c.268 0 .485.218.485.486v4.707z"/>
                    </svg>
                `;
            }

            case 'warning':
            case 'info': {
                return `
                
                <svg   viewBox="0 0 15 15"   width="15"   height="15">
                <g
                     transform="matrix(0.18644068,0,0,0.18644068,-1.4135078,-1.9656032)">
                    <path
                       d="M 48,15.5 C 30,15.5 15.5,30 15.5,48 15.5,66 30,80.5 48,80.5 66,80.5 80.5,66 80.5,48 80.5,30 66,15.5 48,15.5 Z m 0,5.4 C 62.9,20.9 75.1,33 75.1,48 75.1,62.9 63,75.1 48,75.1 33,75.1 20.9,62.9 20.9,48 20.9,33.1 33.1,20.9 48,20.9 Z m 0,9.9 c -2.2,0 -3.9,1.7 -3.9,3.9 0,2.2 1.7,3.9 3.9,3.9 2.2,0 3.9,-1.7 3.9,-3.9 0,-2.1 -1.7,-3.9 -3.9,-3.9 z m -3.1,10 V 65.3 H 51 V 40.8 Z" 
                   style="fill:#FFF" />
                </g>
                </svg>
                `
            }
        }
    }

}

registerUIService(XMessageUIService);